import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Dimmer, Message, Progress } from "semantic-ui-react";
import TitlePage from "./components/TitlePage";
import DataTable from "./components/DataTable";
import UnitGraphs from "./components/UnitGraphs";
import Questions from "./components/Questions";
import AllDomainsGraph from "./components/AllDomainsGraph";
import Sidebar from "./components/Sidebar";
import MagnetReportHeader from "../../components/SRHHeaders/MagnetReportHeader";
import {
  PageWrapper,
  PageContent,
  DimmerStyle,
  SidebarWrapper,
  Footer,
  FooterLeft,
  FooterCenter,
  FooterRight,
  MessageContainer,
  MessageTitle,
  MessageContent,
  ActionArea,
  ExpandButton,
} from "./style.js";
import Button from "@material-ui/core/Button";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { magnetReportOperations } from "./../../redux/magnetReport";
import { magnetWorkSettingOperations } from "./../../redux/magnetWorkSetting";
import { magnetWorkSettingsOperations } from "./../../redux/magnetWorkSettings";
import { benchmarksOperations } from "./../../redux/benchmarks";
import { questionsOperations } from "./../../redux/questions";
import { magnetFooterActions } from "./../../redux/magnetFooter";
import { calculateBestCombinations } from "../../lib/magnetAlgorithm";
import axios from "axios";
import parse from "url-parse";
import moment from "moment";
import _ from "lodash";
import ReactGA from "react-ga";
ReactGA.initialize("UA-52754256-15");

class MagnetReport extends Component {
  constructor(props) {
    super(props);
    const id = this.props.match ? this.props.match.params.id : this.props.id;
    this.state = {
      id,
      unit: parse(this.props.location.search, true).query.unit,
      token: this.props.sharedMagnetReport
        ? this.props.sharedMagnetReport.token
        : undefined,
      loaded: false,
      domainCombinations: [],
      domainCombinationSelected: 0,
    };
    this.loadData(id);
    this.googleEventGenerateReport = this.googleEventGenerateReport.bind(this);
    this.setSelectedDomains = this.setSelectedDomains.bind(this);
    this.setUnit = this.setUnit.bind(this);
  }

  googleEventGenerateReport() {
    const { datasetName } = this.props.magnetReport.magnetReport;
    const { unit } = this.state;
    if (unit === "facility") {
      ReactGA.event({
        category: datasetName,
        action: "generate_facility_magnet_report",
        label: `MAGNET_Questions_Report_${datasetName}_${moment().format(
          "MMDDYYYY"
        )}.pdf`,
      });
    } else if (unit) {
      ReactGA.event({
        category: datasetName,
        action: "generate_unit_magnet_report",
        label: `MAGNET_Report_${datasetName}_${unit}_${moment().format(
          "MMDDYYYY"
        )}.pdf`,
      });
    } else {
      ReactGA.event({
        category: datasetName,
        action: "generate_magnet_report",
        label: `MAGNET_Report_${datasetName}_${moment().format(
          "MMDDYYYY"
        )}.pdf`,
      });
    }
  }

  setSelectedDomains(value) {
    this.setState({ domainCombinationSelected: value });
  }

  setId(id) {
    this.setState({ id });
    this.loadData(id);
  }

  setUnit(unitIn) {
    const { unit } = this.state;
    const params = parse(this.props.location.search, true).query;
    if (unitIn === "magnet") {
      delete params.unit;
    } else {
      params.unit = encodeURIComponent(unitIn); //unitIn.replace(/&/g, "%26");
    }

    this.props.history.push({
      search: `?${_.map(_.toPairs(params), function (param) {
        return `${param[0]}=${param[1]}`;
      }).join("&")}`,
    });

    if (unitIn === "magnet") {
      unitIn = undefined;
    }
    if (unitIn !== unit) {
      this.setState({ unit: unitIn });
      this.props.dispatch(questionsOperations.clear());
    }
  }

  loadData(id) {
    const { sharedMagnetReport } = this.props;
    const { token } = this.state;
    const options = { token };
    if (sharedMagnetReport) {
      options.sharedMagnetReport = sharedMagnetReport;
    }
    this.props.dispatch(magnetReportOperations.fetchMagnetReport(id, options));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { magnetReport, magnetWorkSettings } = nextProps;
    let state = {};
    if (
      magnetReport.fetched &&
      magnetWorkSettings.fetched &&
      !prevState.loaded
    ) {
      state.loaded = true;
    }
    if (
      (prevState.loaded || state.loaded) &&
      prevState.domainCombinations.length < 1
    ) {
      state = {
        ...state,
        ...calculateBestCombinations(
          nextProps.magnetWorkSettings.magnetWorkSettings,
          nextProps.benchmarks,
          nextProps.dispatch
        ),
      };
    }
    return state;
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      magnetReport,
      magnetWorkSettings,
      magnetWorkSetting,
      questions,
      sharedMagnetReport,
      benchmarks,
    } = this.props;
    const { token, unit } = this.state;
    const error = magnetReport.error || magnetWorkSettings.error;
    if (magnetReport.fetched && !error) {
      const options = { token, ...magnetReport.magnetReport, appliedBenchmark: benchmarks };
      const tableId = `${magnetReport.magnetReport.datasetId}_${magnetReport.magnetReport.resultSetId}`;

      const magnetReportJustLoaded =
        !prevProps.magnetReport.fetched && magnetReport.fetched;
      const unitJustChanged = prevState.unit !== unit;
      if (magnetReportJustLoaded || unitJustChanged) {
        this.props.dispatch(benchmarksOperations.fetchBenchmarks(options));
      }

      const benchmarksJustLoaded =
        !prevProps.benchmarks.fetched && benchmarks.fetched;
      if (benchmarksJustLoaded) {
        this.googleEventGenerateReport();
        if (!unit) {
          this.props.dispatch(
            magnetWorkSettingsOperations.fetchMagnetWorkSettings(
              tableId,
              options
            )
          );
        } else if (unit === "facility") {
          delete options.units;
          this.props.dispatch(
            questionsOperations.fetchQuestions(tableId, options)
          );
        } else {
          options.unit = unit;
          this.props.dispatch(
            magnetWorkSettingOperations.fetchMagnetWorkSetting(tableId, options)
          );
        }
      }

      const magnetWorkSettingJustLoaded =
        !prevProps.magnetWorkSetting.fetched && magnetWorkSetting.fetched;
      if (magnetWorkSettingJustLoaded) {
        options.units = [unit];
        this.props.dispatch(
          questionsOperations.fetchQuestions(tableId, options)
        );
      }
    }
    const justLoaded =
      magnetReport.fetched &&
      (questions.fetched || magnetWorkSettings.fetched) &&
      !magnetReport.error &&
      !magnetWorkSettings.error &&
      (!prevProps.magnetReport.fetched ||
        !prevProps.magnetWorkSettings.fetched);
    const justFailed =
      !prevProps.magnetReport.error &&
      !prevProps.magnetWorkSettings.error &&
      !prevProps.questions.error &&
      error;
    if (justLoaded && sharedMagnetReport) {
      axios.post(
        `/api/shared-summary-reports/${sharedMagnetReport.token}/view`
      );
    }
    if (justFailed && sharedMagnetReport) {
      axios.post(
        `/api/shared-summary-reports/${sharedMagnetReport.token}/error`
      );
    }
  }

  render() {
    const {
      magnetFooter,
      magnetReport,
      magnetWorkSettings,
      magnetWorkSetting,
      questions,
      user,
      benchmarks,
      dispatch,
    } = this.props;
    const { domainCombinations, domainCombinationSelected, unit } = this.state;
    const { workSettings } = magnetReport.magnetReport;
    const domainCombination = domainCombinations[domainCombinationSelected];

    const breadcrumbs = [];
    if (magnetReport.magnetReport.datasetName) {
      breadcrumbs.push(magnetReport.magnetReport.datasetName);
      if (unit) {
        breadcrumbs.push(unit);
      } else {
        breadcrumbs.push("magnet");
      }
    }

    let ready;
    if (!unit) {
      ready = magnetReport.fetched && magnetWorkSettings.fetched;
    } else {
      ready = magnetReport.fetched && questions.fetched;
    }
    const error =
      magnetReport.error ||
      magnetWorkSettings.error ||
      magnetWorkSetting.error ||
      questions.error;

    let dataTablePageNumber = 2;
    let unitGraphPageNumber = 2;
    let allDomainsGraphPageNumber = 2;
    let questionsPageNumber = unit !== "facility" ? 3 : 2;

    if (ready && magnetWorkSettings.fetched) {
      const pageOneSize = 16;
      const pageSize = 17;
      let addPagesForDataTable = 0;
      if (domainCombination.units.length > pageOneSize) {
        addPagesForDataTable =
          Math.ceil((domainCombination.units.length - pageOneSize) / pageSize) +
          1;
      } else {
        addPagesForDataTable = 1;
      }
      unitGraphPageNumber += addPagesForDataTable;
    }

    let progress;
    if (!unit) {
      progress = Math.min(
        Math.floor(
          ((magnetReport.fetched ? 100 : 0) +
            magnetWorkSettings.progress * 19) /
            20
        ),
        100
      );
    } else if (unit === "facility") {
      progress = Math.min(
        Math.floor(
          ((magnetReport.fetched ? 100 : 0) + questions.progress * 19) / 20
        ),
        100
      );
    } else {
      progress = Math.min(
        Math.floor(
          ((magnetReport.fetched ? 100 : 0) +
            magnetWorkSetting.progress +
            questions.progress * 18) /
            20
        ),
        100
      );
    }

    let unitData;
    if (unit) {
      let responseCount;
      let responseRate;
      for (let i = 0; i < workSettings.length; i++) {
        const workSetting = workSettings[i];
        if (workSetting.unit === unit) {
          responseCount = workSetting.count;
          responseRate = workSetting.response_rate;
        }
      }
      unitData = {
        name: unit,
        responseCount,
        responseRate,
      };
    }

    const rerunReport = () => {
      this.setState(
        calculateBestCombinations(
          magnetWorkSettings.magnetWorkSettings,
          benchmarks,
          dispatch
        )
      );
      dispatch(magnetFooterActions.hideFooter());
    };

    return (
      <PageWrapper>
        <MagnetReportHeader
          {...this.props}
          ready={ready}
          breadcrumbs={breadcrumbs}
          unit={unit}
          units={magnetReport.magnetReport.workSettingReports}
          setUnit={this.setUnit}
          user={user}
          magnetReport={magnetReport.magnetReport}
        />
        {error && (
          <Container>
            <Message
              error
              header="We encountered an error. Try reloading the page."
              // content={magnetReport.error.data.response}
            />
          </Container>
        )}
        {!error && (
          <Dimmer.Dimmable as={PageContent}>
            <Dimmer as={DimmerStyle} active className={ready ? "hide" : ""}>
              <div style={{ width: "600px", margin: "auto" }}>
                <div style={{ marginBottom: "7px", textAlign: "left" }}>
                  Loading report...
                </div>
                <Progress
                  percent={progress}
                  active
                  progress="percent"
                  color="orange"
                />
              </div>
            </Dimmer>
            <SidebarWrapper>
              <div className="fill">
                <div id="divToPrint">
                  <TitlePage
                    ready={ready}
                    magnetReport={magnetReport.magnetReport}
                    domainCombination={domainCombination}
                    unit={unitData}
                  />
                  {!unit && (
                    <DataTable
                      ready={ready}
                      domainCombination={domainCombination}
                      page={dataTablePageNumber}
                    />
                  )}
                  {!unit && (
                    <UnitGraphs
                      ready={ready}
                      domainCombination={domainCombination}
                      page={unitGraphPageNumber}
                    />
                  )}
                  {unit && unit !== "facility" && (
                    <AllDomainsGraph
                      ready={ready}
                      page={allDomainsGraphPageNumber}
                      unit={unitData}
                    />
                  )}
                  {unit && (
                    <Questions
                      ready={ready}
                      showAllQuestions={true}
                      showAllQuestionInlineValues={true}
                      page={questionsPageNumber}
                      unit={unitData}
                    />
                  )}
                </div>
              </div>
              <Sidebar
                domainCombinations={domainCombinations}
                domainCombinationSelected={domainCombinationSelected}
                setSelectedDomains={this.setSelectedDomains}
              />
            </SidebarWrapper>
            <Footer show={magnetFooter.showFooter} expand={magnetFooter.expandFooter}>
              <FooterLeft />
              <FooterCenter>
                <MessageContainer>
                  <MessageTitle> Rerun Magnet Report? </MessageTitle>
                  <MessageContent>
                    You’ve selected additional benchmarks to test. When you
                    rerun the report it will apply the benchmarks that give you
                    the best opportunity to pass. You can still go back and
                    change which benchmarks you want to apply.
                  </MessageContent>
                </MessageContainer>
                <ActionArea>
                  <Button
                    fullWidth
                    color="secondary"
                    variant="contained"
                    onClick={rerunReport}
                  >
                    Rerun Report
                  </Button>
                </ActionArea>
              </FooterCenter>
              <FooterRight>
                {magnetFooter.expandFooter}
                {magnetFooter.expandFooter ? (
                  <ExpandButton
                    endIcon={<ExpandMoreIcon />}
                    onClick={() =>
                      dispatch(magnetFooterActions.collapseFooter())
                    }
                  >
                    Hide
                  </ExpandButton>
                ) : (
                  <ExpandButton
                    endIcon={<ExpandLessIcon />}
                    onClick={() => dispatch(magnetFooterActions.expandFooter())}
                  >
                    Show
                  </ExpandButton>
                )}
              </FooterRight>
            </Footer>
          </Dimmer.Dimmable>
        )}
      </PageWrapper>
    );
  }
}

export default connect((store) => {
  return {
    magnetFooter: store.magnetFooter,
    magnetReport: store.magnetReport,
    magnetWorkSettings: store.magnetWorkSettings,
    magnetWorkSetting: store.magnetWorkSetting,
    benchmarks: store.benchmarks,
    questions: store.questions,
    user: store.user,
  };
})(MagnetReport);



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/index.jsx